import { NewClassroomPin } from '@models/new-classroom-pin';
import { ObjectHelperBaseObject } from '@models/object-helper-base';

export class UserPrefs extends ObjectHelperBaseObject {
  private _classroomPins: Map<string, NewClassroomPin> = new Map<string, NewClassroomPin>();

  set classroomPins(classroomPins: object) {
    this._classroomPins = new Map<string, NewClassroomPin>(Object.entries(classroomPins));
  }

  get classroomPins(): Map<string, NewClassroomPin> {
    return this._classroomPins;
  }
}
